export default "/images/vendor/flag-icons/flags/4x3/sy.svg?a7d9792964e74fe3a58f7feb4ccff29e";